/* Extra keepers — the "choose exactly N" rule. HEllO EDC (India store).
   Added 13 Oct 2026.

   WHY
   PLAY with FLEXA comes with 2 extra keepers and THE F1 APEX with 1. The
   colours are chosen in Easify Options, which only checks the count when Add
   to Cart is pressed, and shows its complaint inside its own block. On a
   phone that block is a bottom sheet parked off-screen
   (assets/wc-keepers-drawer.css), so the complaint is never seen: the button
   simply does nothing. Three problems followed from that:

   1. Nothing said how many to choose, and nothing stopped a third, fourth or
      fifth colour being picked (order #MLG10361 arrived with five).
   2. Pick the wrong number, press Add to Cart, and nothing happened — a
      dead click.
   3. The sticky Add to Cart bar on mobile submits the form directly. It skips
      both the guided button (assets/wc-guided-atc.js) and Easify's check, so
      a strap could reach the cart with no keepers chosen at all (#MLG10606,
      #MLG10607 and others).

   WHAT THIS FILE DOES
   - Reads the number to choose from the product metafield
     custom.keepers_required (rendered by snippets/buy-buttons.liquid). A
     product without that metafield is left alone entirely.
   - Shows a line at the top of the keepers picker: "Choose 2 keeper colours ·
     1 of 2 chosen", updated live.
   - Stops a choice beyond the limit and says why. When the limit is 1, a new
     tap swaps the colour instead.
   - Drives the mobile keepers button: it reads "Select" (plus "1 of 2")
     until the count is right, and only then the colours. The guided Add to
     Cart button (assets/wc-guided-atc.js) reads that caption, so it now
     stays on "open the keepers" until the right number is chosen.
   - Guards every add to cart from this page (main button, sticky bar, a
     native post), ahead of every other handler: if the count is wrong, the
     add is stopped, the picker is opened (or scrolled to) and the line turns
     red with what is missing. Never a dead click.

   HOW IT READS EASIFY
   Easify has no public state object. A keepers block is a visible
   .po-option-root that contains image swatches (img.po-imageOption-swatch).
   What is chosen is read from that block's own form fields — the same fields
   that become the order's line properties — and only values matching a
   swatch's name are counted, so a checkbox such as "Install these as my
   default keepers" never counts. If no fields are found, swatches marked
   selected/checked are counted instead.

   If no keepers block is on the page (Easify not loaded, or this colour has
   no keepers option) the rule stands aside rather than blocking a sale. */

(function () {
  'use strict';

  if (window.__wcKeepersRule) return;
  window.__wcKeepersRule = true;

  var cfgEl = document.querySelector('script[data-wc-keepers]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var NEED = parseInt(cfg && cfg.required, 10);
  if (!(NEED > 0)) return;

  var NOUN = NEED === 1 ? 'keeper colour' : 'keeper colours';
  var error = false;        /* true once an add was stopped, until fixed */
  var flash = '';           /* one-off message after a refused tap */
  var flashTimer = null;
  var order = [];           /* chosen colours in the order they were picked */

  /* ---------- reading Easify ---------- */

  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase(); }

  function visible(el) { return !!(el && el.getClientRects && el.getClientRects().length); }

  function keeperRoots() {
    var all = document.querySelectorAll('.po-option-root');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var r = all[i];
      if (r.parentElement && r.parentElement.closest('.po-option-root')) continue;   /* nested */
      if (r.closest('.quick-add-modal, quick-add-modal')) continue;
      if (!r.querySelector('img.po-imageOption-swatch')) continue;
      if (!visible(r)) continue;
      out.push(r);
    }
    return out;
  }

  function swatchNames(root) {
    var names = [];
    root.querySelectorAll('img.po-imageOption-swatch').forEach(function (img) {
      var n = (img.getAttribute('alt') || '').trim();
      if (n && names.indexOf(n) < 0) names.push(n);
    });
    return names;
  }

  function canonical(value, names) {
    var v = norm(value);
    for (var i = 0; i < names.length; i++) if (norm(names[i]) === v) return names[i];
    return null;
  }

  function markedSelected(el, root) {
    for (var n = el; n && n !== root.parentElement; n = n.parentElement) {
      if (n.getAttribute) {
        if (n.getAttribute('aria-checked') === 'true' || n.getAttribute('aria-pressed') === 'true' ||
            n.getAttribute('aria-selected') === 'true' || n.getAttribute('data-selected') === 'true') return true;
        var cls = typeof n.className === 'string' ? n.className : '';
        if (/(^|[\s_-])(selected|is-selected|active|is-active|checked|is-checked)(\s|$)/i.test(cls)) return true;
      }
      if (n === root) break;
    }
    return false;
  }

  function chosenIn(root) {
    var names = swatchNames(root);
    var out = [];
    var sawField = false;

    function add(v) {
      var c = names.length ? canonical(v, names) : String(v).trim();
      if (c && out.indexOf(c) < 0) out.push(c);
    }

    root.querySelectorAll('input, select').forEach(function (el) {
      var name = el.name || '';
      if (/^properties\[_/.test(name)) return;
      var type = (el.type || '').toLowerCase();
      if (type === 'checkbox' || type === 'radio') {
        sawField = true;
        if (!el.checked) return;
        var v = el.value && el.value !== 'on' ? el.value : '';
        if (!v) {
          var lab = el.closest('label') || (el.id && root.querySelector('label[for="' + el.id + '"]'));
          var img = lab && lab.querySelector('img.po-imageOption-swatch');
          v = img ? img.getAttribute('alt') : (lab ? lab.textContent : '');
        }
        add(v);
      } else if (el.tagName === 'SELECT') {
        sawField = true;
        Array.prototype.forEach.call(el.options, function (o) { if (o.selected && o.value) add(o.value); });
      } else if (name.indexOf('properties[') === 0) {
        sawField = true;
        String(el.value || '').split(',').forEach(function (v) { if (v.trim()) add(v); });
      }
    });

    if (!sawField || (!out.length && names.length)) {
      root.querySelectorAll('img.po-imageOption-swatch').forEach(function (img) {
        if (markedSelected(img, root)) add(img.getAttribute('alt') || '');
      });
    }
    return out;
  }

  function chosen() {
    var out = [];
    keeperRoots().forEach(function (r) {
      chosenIn(r).forEach(function (v) { if (out.indexOf(v) < 0) out.push(v); });
    });
    /* keep the pick order for captions and for the 1-colour swap */
    order = order.filter(function (v) { return out.indexOf(v) > -1; });
    out.forEach(function (v) { if (order.indexOf(v) < 0) order.push(v); });
    return order.slice();
  }

  function applies() { return keeperRoots().length > 0; }
  function count() { return chosen().length; }
  function ok() { return !applies() || count() === NEED; }

  /* ---------- the line at the top of the picker ---------- */

  function style() {
    if (document.getElementById('wc-keepers-rule-css')) return;
    var s = document.createElement('style');
    s.id = 'wc-keepers-rule-css';
    s.textContent =
      '.wc-keepers-note{display:flex;align-items:center;justify-content:space-between;gap:12px;' +
        'margin:0 0 10px;padding:10px 0 6px;font-size:1.3rem;line-height:1.4;letter-spacing:.02em;color:#121212;}' +
      '.wc-keepers-note__count{font-weight:600;white-space:nowrap;}' +
      '.wc-keepers-note.is-done .wc-keepers-note__count{color:#2e7d32;}' +
      '.wc-keepers-note.is-error{color:#b3261e;}' +
      '.wc-keepers-note.is-error .wc-keepers-note__count{color:#b3261e;}' +
      '.wc-keepers-note__done{display:none;border:0;background:#121212;color:#fff;font-size:1.2rem;' +
        'letter-spacing:.06em;padding:8px 14px;cursor:pointer;}' +
      '.wc-keepers-drawer .wc-keepers-note.is-done .wc-keepers-note__done{display:inline-block;}' +
      '.wc-keepers-drawer .wc-keepers-note{position:sticky;top:0;background:#fff;z-index:1;padding-top:16px;}' +
      '@keyframes wcKeepersShake{0%,100%{transform:none}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}' +
      '.wc-keepers-note.is-shake{animation:wcKeepersShake .3s ease 2;}' +
      '.wc-keepers-progress{display:block;font-size:10px;line-height:1.2;letter-spacing:.04em;color:#6b6b6b;}' +
      '.wc-keepers-progress:empty{display:none;}' +
      '.wc-keepers-progress.is-error{color:#b3261e;font-weight:600;}';
    document.head.appendChild(s);
  }

  function noteFor(root) {
    var note = null;
    for (var i = 0; i < root.children.length; i++) {
      if (root.children[i].classList.contains('wc-keepers-note')) { note = root.children[i]; break; }
    }
    if (!note) {
      note = document.createElement('div');
      note.className = 'wc-keepers-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.innerHTML = '<span class="wc-keepers-note__text"></span>' +
        '<span class="wc-keepers-note__count"></span>' +
        '<button type="button" class="wc-keepers-note__done">DONE</button>';
      root.insertBefore(note, root.firstChild);
    }
    return note;
  }

  /* The mobile keepers button. Its value reads exactly "Select" until the
     count is right, because assets/wc-guided-atc.js treats any other caption
     as "keepers done". The progress ("1 of 2") sits in a span of its own. */
  function caption() {
    var c = chosen();
    return c.length === NEED ? c.join(', ') : 'Select';
  }

  function progress() {
    var n = chosen().length;
    if (n === NEED) return '';
    if (n > NEED) return 'Only ' + NEED;
    return n ? n + ' of ' + NEED : 'Choose ' + NEED;
  }

  var painting = false;
  function paint() {
    if (painting) return;
    painting = true;
    try {
      var c = chosen();
      var n = c.length;
      if (n === NEED) error = false;

      var text, cls = '';
      if (flash) {
        text = flash; cls = 'is-error';
      } else if (n > NEED) {
        text = 'Please choose only ' + NEED + ' — tap a colour to remove it.'; cls = 'is-error';
      } else if (n === NEED) {
        text = NEED === 1 ? 'Keeper colour chosen' : 'Keeper colours chosen'; cls = 'is-done';
      } else if (error) {
        text = 'Choose ' + (NEED - n) + ' more ' + (NEED - n === 1 ? 'keeper colour' : 'keeper colours') + ' to add to cart.';
        cls = 'is-error';
      } else {
        text = 'Choose ' + NEED + ' ' + NOUN + '.';
      }

      keeperRoots().forEach(function (root) {
        var note = noteFor(root);
        var t = note.querySelector('.wc-keepers-note__text');
        var k = note.querySelector('.wc-keepers-note__count');
        if (t.textContent !== text) t.textContent = text;
        var countText = n + ' of ' + NEED + ' chosen';
        if (k.textContent !== countText) k.textContent = countText;
        note.classList.toggle('is-done', cls === 'is-done');
        note.classList.toggle('is-error', cls === 'is-error');

        /* the mobile button that opens this sheet */
        var trig = root.id && document.querySelector('button[aria-controls="' + root.id + '"]');
        if (trig) {
          var cap = trig.querySelector('.mobile-variant-btn__value-option');
          var want = caption();
          if (cap && cap.textContent !== want) cap.textContent = want;
          var prog = trig.querySelector('.wc-keepers-progress');
          if (!prog) {
            prog = document.createElement('span');
            prog.className = 'wc-keepers-progress';
            trig.appendChild(prog);
          }
          var p = progress();
          if (prog.textContent !== p) prog.textContent = p;
          prog.classList.toggle('is-error', error || n > NEED);
        }
      });
    } finally {
      painting = false;
    }
  }

  function shake() {
    keeperRoots().forEach(function (root) {
      var note = noteFor(root);
      note.classList.remove('is-shake');
      void note.offsetWidth;
      note.classList.add('is-shake');
    });
  }

  function say(msg) {
    flash = msg;
    clearTimeout(flashTimer);
    paint();
    shake();
    flashTimer = setTimeout(function () { flash = ''; paint(); }, 3500);
  }

  /* Open the sheet on mobile, or bring the block into view on desktop. */
  function reveal() {
    error = true;
    paint();
    shake();
    var root = keeperRoots()[0];
    if (!root) return;
    if (root.classList.contains('wc-keepers-drawer') && window.innerWidth < 768) {
      if (!root.classList.contains('is-open')) {
        var trigger = root.id && document.querySelector('button[aria-controls="' + root.id + '"]');
        if (trigger) trigger.click();
      }
      return;
    }
    if (root.scrollIntoView) {
      try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (e) { root.scrollIntoView(); }
    }
  }

  /* ---------- the limit ---------- */

  function swatchFrom(target, root) {
    var img = target.closest && target.closest('img.po-imageOption-swatch');
    if (img) return img;
    var item = target.closest && target.closest('label, li, [class*="imageOption"], [class*="Swatch"], [class*="swatch"]');
    while (item && root.contains(item)) {
      var imgs = item.querySelectorAll('img.po-imageOption-swatch');
      if (imgs.length === 1) return imgs[0];
      if (imgs.length > 1) return null;
      item = item.parentElement && item.parentElement.closest('label, li, [class*="imageOption"], [class*="Swatch"], [class*="swatch"]');
    }
    if (target.tagName === 'INPUT' && target.id) {
      var lab = root.querySelector('label[for="' + target.id + '"]');
      var i2 = lab && lab.querySelector('img.po-imageOption-swatch');
      if (i2) return i2;
    }
    return null;
  }

  function itemFor(name, root) {
    var imgs = root.querySelectorAll('img.po-imageOption-swatch');
    for (var i = 0; i < imgs.length; i++) {
      if (norm(imgs[i].getAttribute('alt')) === norm(name)) return imgs[i];
    }
    return null;
  }

  var swapping = false;
  /* A tap on a label fires a second, synthetic click on its input; only the
     first one decides. */
  var lastDecision = { t: 0, alt: '', allow: true };

  window.addEventListener('click', function (e) {
    if (swapping) return;
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest('.wc-keepers-note')) {
      if (target.closest('.wc-keepers-note__done')) {
        var bd = document.querySelector('.rebel-keepers-backdrop.is-open');
        if (bd) bd.click();
      }
      return;
    }
    var root = target.closest('.po-option-root');
    if (!root || keeperRoots().indexOf(root) < 0) return;
    var img = swatchFrom(target, root);
    if (!img) return;
    var alt = (img.getAttribute('alt') || '').trim();

    var now = Date.now();
    if (now - lastDecision.t < 400 && lastDecision.alt === alt) {
      if (!lastDecision.allow) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }

    var c = chosen();
    var isChosen = c.some(function (v) { return norm(v) === norm(alt); });
    var allow = true;

    if (!isChosen && c.length >= NEED) {
      if (NEED === 1) {
        /* single choice: swap, don't refuse */
        var old = itemFor(c[0], root);
        if (old) {
          swapping = true;
          try { old.click(); } finally { swapping = false; }
        }
      } else {
        allow = false;
        e.preventDefault();
        e.stopImmediatePropagation();
        say('You can choose ' + NEED + '. Tap a chosen colour to remove it first.');
      }
    }

    lastDecision = { t: now, alt: alt, allow: allow };
    if (allow) {
      flash = '';
      setTimeout(paint, 0);
      setTimeout(paint, 120);
    }
  }, true);

  /* ---------- the Add to Cart buttons ----------

     assets/wc-guided-atc.js owns the in-page button: while keepers are not
     done it opens the keepers sheet instead of adding. Its click handler
     runs first and stops the event, so the red "choose N more" state is set
     here on pointerdown, which always comes before the click. */
  function pressedAdd(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.dummy-add-to-cart, .sticky-atc-bar__btn--atc, [id^="ProductSubmitButton"]')) return;
    if (ok()) return;
    error = true;
    paint();
    shake();
  }
  window.addEventListener('pointerdown', pressedAdd, true);
  window.addEventListener('touchstart', pressedAdd, true);
  window.addEventListener('mousedown', pressedAdd, true);

  /* On desktop the keepers block is inline and its mobile button is hidden,
     so the guided button "opening" it would show nothing. Bring the block
     into view instead. */
  window.addEventListener('click', function (e) {
    if (window.innerWidth < 768) return;
    var trig = e.target && e.target.closest && e.target.closest('button[aria-controls]');
    if (!trig) return;
    var root = document.getElementById(trig.getAttribute('aria-controls'));
    if (!root || keeperRoots().indexOf(root) < 0) return;
    if (root.scrollIntoView) {
      try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (err) { root.scrollIntoView(); }
    }
  }, true);

  /* ---------- every way into the cart ---------- */

  function isCartAdd(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/.test(action) || form.getAttribute('data-type') === 'add-to-cart-form';
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCartAdd(form)) return;
    if (form.closest('.quick-add-modal, quick-add-modal')) return;
    if (ok()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    reveal();
  }, true);

  /* ---------- public, for wc-keepers-drawer.js (button caption) ---------- */

  window.__wcKeepers = {
    need: NEED,
    applies: applies,
    ok: ok,
    count: count,
    chosen: chosen,
    caption: caption,
    reveal: reveal
  };

  /* ---------- keep it painted ---------- */

  function boot() {
    style();
    paint();
    document.addEventListener('change', function () { setTimeout(paint, 0); }, true);
    var host = document.querySelector('.product__info-wrapper') || document.body;
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (painting || pending) return;
        pending = setTimeout(function () { pending = null; paint(); }, 80);
      }).observe(host, { childList: true, subtree: true });
    }
    /* Easify renders late; check a few times while it settles. */
    var tries = 0;
    var poll = setInterval(function () { paint(); if (++tries >= 12) clearInterval(poll); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
